<template>
  <div class="employer">
    <van-list
      v-if="(list && list.length) || loading"
		  v-model="loading"
		  :finished="finished"
		  finished-text="没有更多了"
		  @load="onLoad"
		>
		  <employer-item v-for="item in list" :item="item"></employer-item>
		</van-list>
    <no-data v-else></no-data>
  </div>
</template>

<script>

	import EmployerItem from '@/components/employer/employerItem'
  import {getList} from '@/api/employer'
  import NoData from "@/components/noData";
export default {
  name: "employer-module",
  data(){
  	return {
  		loading: false,
  		finished: false,
  		list: [],
      page: 1,
      pageSize: 10,
  	}
  },
  components: {
  	EmployerItem, NoData
  },
  methods: {
  	onLoad(){
  		this.loading = true;
      getList({page:this.page, pageSize: this.pageSize}).then(res=>{
        if(res.data && res.data.list){
          this.list = this.list.concat(res.data.list);
          this.page++;
          if(res.data.list.length<this.pageSize)
            this.finished = true;
        }else{
          this.finished = true;
        }
      }).catch(err=>{}).finally(()=>{this.loading = false;})
  	}
  },
  created() {
    this.onLoad();
    this.$store.commit('comp/WX_SHARE',{
      title:'猎上网 - 新鲜雇主、新鲜职位',
      desc:'重新定义人才服务'
    });
  }
};
</script>

<style scoped lang="scss">
  .van-list{
    background: #f5f5f5;
  }
</style>